import '@fontsource/lora/latin.css';
import '@fontsource/open-sans/latin.css';
import '@fortawesome/fontawesome-svg-core';
import PropTypes from 'prop-types';
import React from 'react';
import '../scss/style.scss';
import Footer from './Footer';
import Header from './Header';
import SEO from './SEO';

const Layout = ({ bodyClass, children }) => (
  <div className={`page${bodyClass ? ` ${bodyClass}` : ''}`}>
    <div id="wrapper" className="wrapper">
      <Header />
      {children}
    </div>
    <Footer />
  </div>
);

export const Head = () => <SEO />;

Layout.propTypes = {
  bodyClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Layout.defaultProps = {
  bodyClass: '',
};

export default Layout;
